module.exports = __webpack_public_path__ + "static/media/service-game.8785e539.jpg";